import { useContext } from 'react';
import { StoreContext } from '~/stores/root-cx-store.provider';
import type { CXRootStore, PublicCXRootStore } from './cx-root.store';
import type { TRootStore } from '~/types/app.types';
import { ensureRootStoreInit } from '~/stores/root-store.utils';

export function useCXRootStore() {
    const cxRootStore = useContext<TRootStore>(StoreContext) as CXRootStore;

    ensureRootStoreInit(cxRootStore);

    return cxRootStore;
}

export function useLeadFormCXRootStore() {
    const cxRootStore = useContext<TRootStore>(
        StoreContext
    ) as PublicCXRootStore;

    ensureRootStoreInit(cxRootStore);

    return cxRootStore;
}
